// OfferFilters.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as OfferStore from '../store/Offer';
import Select from "./Select";
import * as Styles from '../styles/baseStyle';
import { getText } from '../utils/texts';
import { createSelector } from 'reselect';
import * as _ from 'lodash';

interface OfferFiltersOwnProps {
    isDarkMode: boolean;
}

interface OfferFiltersConnectedProps {
    filter: any;
    familiesByNameAndIds: { label: string, value: number | undefined }[];
    subFamiliesByNameAndIds: { label: string, value: number | undefined, familyId?: number }[];
    updateOfferFilter: (filter: any) => void;
}

type OfferFiltersProps = OfferFiltersOwnProps & OfferFiltersConnectedProps;

const OfferFilters: React.FC<OfferFiltersProps> = React.memo(({
    filter,
    familiesByNameAndIds,
    subFamiliesByNameAndIds,
    updateOfferFilter,
    isDarkMode
}) => {
    const bgColor = isDarkMode ? "#181F3A" : "#FFFFFF";

    const handleFamilyChange = React.useCallback((value) => {
        updateOfferFilter({ ...filter, familyId: value });
    }, [filter, updateOfferFilter]);

    const handleSubFamilyChange = React.useCallback((value) => {
        updateOfferFilter({ ...filter, subFamilyId: value });
    }, [filter, updateOfferFilter]);

    const handleNameChange = React.useCallback((e) => {
        updateOfferFilter({ ...filter, productName: e.target.value });
    }, [filter, updateOfferFilter]);

    const handleOfferChange = React.useCallback((value) => {
        updateOfferFilter({ ...filter, hasOffer: value });
    }, [filter, updateOfferFilter]);

    return (
        <div className="selectors" style={{ display: 'flex', margin: '0 1% 1% 1%' }}>
            <div style={{ margin: "0px 1px", width: '25%' }}>
                <div style={Styles.filterLabelStyle}>{getText("OfferFamily")} :</div>
                <div className="card" style={{ ...Styles.cardStyle, ...Styles.filterControlStyle }}>
                    <Select
                        options={familiesByNameAndIds}
                        value={filter.familyId}
                        onChange={handleFamilyChange}
                        style={{ background: bgColor }}
                    />
                </div>
            </div>

            <div style={{ margin: "0px 1px", width: '25%' }}>
                <div style={Styles.filterLabelStyle}>{getText("OfferSubfamily")} :</div>
                <div className="card" style={{ ...Styles.cardStyle, ...Styles.filterControlStyle }}>
                    <Select
                        options={subFamiliesByNameAndIds}
                        value={filter.subFamilyId}
                        onChange={handleSubFamilyChange}
                        style={{ background: bgColor, width: 290 }}
                    />
                </div>
            </div>

            <div style={{ margin: "0px 1px", width: '25%' }}>
                <div style={Styles.filterLabelStyle}>{getText("OfferName")} :</div>
                <div className="card" style={{ ...Styles.cardStyle, ...Styles.filterControlStyle }}>
                    <input
                        type="text"
                        style={{ height: 40 }}
                        className="form-control input-sm"
                        value={filter.productName || ''}
                        onChange={handleNameChange}
                    />
                </div>
            </div>

            <div style={{ margin: "0px 1px", width: '25%' }}>
                <div style={Styles.filterLabelStyle}>{getText("OfferHavePromo")} :</div>
                <div className="card" style={{ ...Styles.cardStyle, ...Styles.filterControlStyle }}>
                    <Select
                        options={[
                            { label: "------", value: undefined },
                            { label: getText("OfferYes"), value: true },
                            { label: getText("OfferNo"), value: false }
                        ]}
                        value={filter.hasOffer}
                        onChange={handleOfferChange}
                        style={{ background: bgColor }}
                    />
                </div>
            </div>
        </div>
    );
});

// Selectors
const getFamilies = (state: ApplicationState) => { return state.seed.seed.families };
const getSubFamilies = (state: ApplicationState) => state.seed.seed.subFamilies;

const familiesByNameAndIdsSelector = createSelector(
    [getFamilies],
    (families) => {
        let result = [
            { label: "------", value: undefined },
            ..._.values(families).map(x => ({
                label: x.name,
                value: x.familyId
            }))
        ]
        return result;
    }
);

const subFamiliesByNameAndIdsSelector = createSelector(
    [getSubFamilies],
    (subFamilies) => [
        { label: "------", value: undefined, familyId: undefined },
        ..._.values(subFamilies).map(x => ({
            label: x.name,
            value: x.subFamilyId,
            familyId: x.familyId
        }))
    ]
);

const mapStateToProps = (state: ApplicationState) => ({
    filter: state.offer.filter,
    familiesByNameAndIds: familiesByNameAndIdsSelector(state),
    subFamiliesByNameAndIds: subFamiliesByNameAndIdsSelector(state)
});

const mapDispatchToProps = {
    updateOfferFilter: OfferStore.actionCreators.updateOfferFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(OfferFilters);